import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// 星盘页全局样式（原 global.css）。该文件内所有规则都已用 :where(#AstrolabeView)
// 限定在星盘根节点内，因此在此全局引入不会污染 /tianxing/* 等其它路由页面。
// 天星页面的样式由其自身 scoped style 与 .tianxing-page 作用域保证。
import './assets/styles/global.css'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
